import { render, staticRenderFns } from "./wechatCustomer.vue?vue&type=template&id=7d482018&scoped=true&"
import script from "./wechatCustomer.vue?vue&type=script&lang=js&"
export * from "./wechatCustomer.vue?vue&type=script&lang=js&"
import style0 from "./wechatCustomer.vue?vue&type=style&index=0&id=7d482018&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d482018",
  null
  
)

export default component.exports